<template>
  <v-card>
    <v-card-title>Equipment and/or services to be provided</v-card-title>
    <v-card-text>
      <a href="" @click.prevent="nav('equipment_list', 2)">{{ equipmentType }} Equipment</a><br>
      <a href="" @click.prevent="nav('equipment_list', 2)">Miscellaneous Equipment</a><br>
      <a href="" @click.prevent="nav('site_staff', 4)">Site Staff</a><br>
      <v-checkbox
        v-model="bReviewed"
        label="I have reviewed and/or updated the above items"
        @change="check($event)"
        :disabled=loading
      ></v-checkbox>
    </v-card-text>
  </v-card>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/functions'

export default {
  props: {
    assignment_data: Object
  },
  data() {
    return {
      bReviewed: false,
      loading: false
    }
  },
  computed: {
    equipmentType() {
      return this.assignment_data.performance_site != undefined ? this.assignment_data.performance_site.type : ''
    }
  },
  methods: {
    check(bool) {
      const vm = this
      const id = vm.$store.state.assignment
      const putOpusApi = firebase.functions().httpsCallable('putOpusApi')

      vm.loading = true
      putOpusApi({
        table: `vendor_assignments`,
        params: {
          id: id,
          B_Equipment_Reviewed: bool
        }
      }).then(function() {
        vm.loading = false
        vm.$emit('loaddata')
      })
    },
    nav(nav, index) {
      const plusN = this.$vuetify.breakpoint.mdAndDown ? 1 : 0

      this.$store.commit('setNavIndex', index + plusN)
      this.$store.commit('setNav', nav)
    }
  },
  mounted() {
    this.bReviewed = this.assignment_data.b_equipment_reviewed
  }
}
</script>